export function registerStores(stores) {
  for (const storeName in stores) {
    if (!On.Store.state[storeName]) On.Store.registerModule(storeName, stores[storeName])
  }
}
